import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class Structures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: '',
      linearFeet: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeArea = this.handleChange.bind(null, 'area');
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeLinearFeet = this.handleChange.bind(null, 'linearFeet');
  }
  handleChange(key, value) {
    const onCalc = this.props.onCalc;
    this.setState({
      [key]: value
    }, () => {
      const _this$state = this.state,
        area = _this$state.area,
        linearFeet = _this$state.linearFeet,
        amount = _this$state.amount;
      if (area !== '' && linearFeet !== '' && amount !== '') {
        // Calculate the surface area
        const total = area * linearFeet * amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const _this$state2 = this.state,
      area = _this$state2.area,
      linearFeet = _this$state2.linearFeet,
      amount = _this$state2.amount;
    const result = this.props.result;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "(FT", /*#__PURE__*/React.createElement("sup", null, "2"), "/Linear FT) x Linear FT x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "FT\xB2/Linear FT",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeArea,
      value: area
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Linear FT",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeLinearFeet,
      value: linearFeet
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
Structures.defaultProps = {
  onCalc: null,
  result: null
};
Structures.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};